module.exports = __webpack_public_path__ + "img/1679985278699-IMG_20230328_134950.jpg.1f452741.webp";